import { render } from "./patent.vue?vue&type=template&id=9c2cbe80&scoped=true"
import script from "./patent.vue?vue&type=script&lang=js"
export * from "./patent.vue?vue&type=script&lang=js"

import "./patent.vue?vue&type=style&index=0&id=9c2cbe80&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c2cbe80"]])

export default __exports__